export interface GenericPostPlaceholders {
	number?: string;
	terminal: string;
}

interface GenericPostRequest {
	body: URLSearchParams;
	url: string;
}

const resolvePlaceholders = (template: string, placeholders: GenericPostPlaceholders): string => {
	const { number, terminal } = placeholders;
	const withTerminal = template.replace(/#MSN#/g, () => terminal);

	return number === undefined ? withTerminal : withTerminal.replace(/#NUM#/g, () => number);
};

export const buildGenericPostRequest = (
	template: string,
	placeholders: GenericPostPlaceholders
): GenericPostRequest => {
	const resolved = resolvePlaceholders(template, placeholders);
	const separatorIndex = resolved.indexOf('?');

	if (separatorIndex === -1) {
		return { body: new URLSearchParams(), url: resolved };
	}

	return {
		body: new URLSearchParams(resolved.slice(separatorIndex + 1)),
		url: resolved.slice(0, separatorIndex),
	};
};
